"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CEntry = void 0;
exports.filterLastRevision = filterLastRevision;
exports.getOrderingValue = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * The fields an Entry must have!
 */
class CEntry {
  constructor() {
    /**
     * the id must be unique across all entities of the data-layer
     */
    _defineProperty(this, "entryId", null);
    /**
     * the primary key, not necessarily unique, but must be unique in combination with the rangeKey
     */
    _defineProperty(this, "primaryKey", null);
    /**
     * second part of the overall primary key
     */
    _defineProperty(this, "rangeKey", null);
    /**
     * a DynamoDb expression to apply on putItem
     */
    _defineProperty(this, "ConditionExpression", null);
  }
}
exports.CEntry = CEntry;
;
;
function filterLastRevision(entries, plain) {
  //console.log(entries)
  if (!entries) {
    return [];
  }
  return Object.values(entries.reduce((result, entry) => {
    var _result$entryKey;
    const keys = [plain.primaryKey, plain.rangeKey].flat().filter(k => k !== "revision");
    const entryKey = keys.reduce((acc, cur) => `${acc}${entry[cur]}`, "");
    if (!(result !== null && result !== void 0 && result[entryKey]) || entry.revision > (result === null || result === void 0 || (_result$entryKey = result[entryKey]) === null || _result$entryKey === void 0 ? void 0 : _result$entryKey.revision)) {
      var _result$entryKey$orig, _result$entryKey2;
      result[entryKey] = _objectSpread(_objectSpread({}, entry), {}, {
        orig_revision: (_result$entryKey$orig = result === null || result === void 0 || (_result$entryKey2 = result[entryKey]) === null || _result$entryKey2 === void 0 ? void 0 : _result$entryKey2.orig_revision) !== null && _result$entryKey$orig !== void 0 ? _result$entryKey$orig : entry.revision
      });
    } else if (entry.revision < result[entryKey].orig_revision) {
      result[entryKey].orig_revision = entry.revision;
    }
    return result;
  }, {}));
}
;

//export const isActive = (entry: IEntry) => entry?.change !== EntryChange.deleted;
//export const onlyActive = (entries: Array<IEntry>) => entries.filter(isActive);

const getOrderingValue = (lowerValue, upperValue) => {
  const order = '0123456789abcdefghijklmnopqrstuvwxyz';

  // this should not happen - two identical positions. There is no correct solution, 
  // but this one prevents crashing
  if (upperValue && (lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.localeCompare(upperValue)) == 0) {
    return `${lowerValue}h`;
  }
  //console.log("compare ", lowerValue, upperValue)

  // 0 is falsy!

  const lowerPos = typeof lowerValue === "string" && lowerValue[0] !== undefined ? order.indexOf(lowerValue[0]) : 0;
  const upperPos = typeof upperValue === "string" && upperValue[0] !== undefined ? order.indexOf(upperValue[0]) : order.length - 1;
  const difference = upperPos - lowerPos;
  if (difference < 2) {
    var _upperValue$length, _lowerValue$length;
    // use the lower value
    //console.log("DIFFERENCE", lowerValue, upperValue)
    return `${order.charAt(lowerPos)}${getOrderingValue(lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.slice(1), difference === 0 || ((_upperValue$length = upperValue === null || upperValue === void 0 ? void 0 : upperValue.length) !== null && _upperValue$length !== void 0 ? _upperValue$length : 0) > ((_lowerValue$length = lowerValue === null || lowerValue === void 0 ? void 0 : lowerValue.length) !== null && _lowerValue$length !== void 0 ? _lowerValue$length : 0) ? upperValue === null || upperValue === void 0 ? void 0 : upperValue.slice(1) : null)}`;
  } else {
    return order.charAt(difference / 2 + lowerPos);
  }

  //console.log(lowerValue, upperValue, lowerPos, upperPos, (upperPos-lowerPos)/2, result)
};
exports.getOrderingValue = getOrderingValue;